import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoginLayout } from '@cfp/shared/ui/login';
import { FooterText } from '../../components';

@Component({
  selector: 'cfp-authentication-page',
  templateUrl: './authentication-page.html',
  imports: [RouterOutlet, FooterText, LoginLayout]
})
export class AuthenticationPage {
  constructor() {
    window.scrollTo(0, 0);
  }
}
